/* import __COLOCATED_TEMPLATE__ from './output-signal.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type CircuitService from '../services/circuit';
import type DisplayOptionsService from '../services/display-options';

interface OutputSignalPanelSignature {
  Element: HTMLDivElement;
}
export default class OutputSignalPanel extends Component<OutputSignalPanelSignature> {
  @service declare displayOptions: DisplayOptionsService;
  @service declare circuit: CircuitService;

  get optionsMask() {
    const filter = [];
    filter.push(!!this.displayOptions.dacImagesFilter);
    filter.push(!!(this.displayOptions.harmonicsFilter && this.displayOptions.harmonics2Filter));
    filter.push(!!(this.displayOptions.harmonicsFilter && this.displayOptions.harmonics3Filter));
    filter.push(!!this.displayOptions.pptSpurFilter);
    filter.push(!!this.displayOptions.fundamentalFilter);
    return filter;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    OutputSignal: typeof OutputSignalPanel;
  }
}
